// Cognito configuration for Parent Application

export interface CognitoConfig {
  userPoolId: string;
  clientId: string;
  domain: string;
  region: string;
}

// Validate required environment variables
const validateEnvVar = (name: string, value: string | undefined): string => {
  if (!value) {
    console.error(`Missing required environment variable: ${name}`);
    console.error('Available env vars:', import.meta.env);
    throw new Error(`Missing required environment variable: ${name}`);
  }
  return value;
};

export const cognitoConfig: CognitoConfig = {
  userPoolId: validateEnvVar('VITE_COGNITO_USER_POOL_ID', import.meta.env.VITE_COGNITO_USER_POOL_ID),
  clientId: validateEnvVar('VITE_COGNITO_CLIENT_ID', import.meta.env.VITE_COGNITO_CLIENT_ID),
  domain: validateEnvVar('VITE_COGNITO_DOMAIN', import.meta.env.VITE_COGNITO_DOMAIN),
  region: import.meta.env.VITE_AWS_REGION || 'us-east-1'
};

// Log config in development
if (import.meta.env.DEV) {
  console.log('Cognito configuration loaded:', {
    userPoolId: cognitoConfig.userPoolId ? '✓' : '✗',
    clientId: cognitoConfig.clientId ? '✓' : '✗',
    domain: cognitoConfig.domain ? '✓' : '✗',
    region: cognitoConfig.region
  });
}

export const getCognitoHostedUIUrl = (): string => {
  const hostedUIUrl = import.meta.env.VITE_COGNITO_HOSTED_UI_URL;
  if (hostedUIUrl) {
    return hostedUIUrl;
  }
  return `https://${cognitoConfig.domain}.auth.${cognitoConfig.region}.amazoncognito.com`;
};

export const getOAuthUrls = () => {
  const baseUrl = getCognitoHostedUIUrl();
  const redirectUri = import.meta.env.VITE_OAUTH_CALLBACK_URL || 'http://localhost:5174/auth/callback';
  const logoutUri = import.meta.env.VITE_OAUTH_LOGOUT_URL || 'http://localhost:5174/';

  return {
    login: `${baseUrl}/oauth2/authorize`,
    token: `${baseUrl}/oauth2/token`,
    logout: `${baseUrl}/logout`,
    redirectUri,
    logoutUri
  };
};
